import { ViewDocumentIcon } from 'Assets/icons'
import { CommonToolTip, CstmPagination } from 'components/Common/Common'
import ErrorComponent from 'components/shared/ErrorComponent'
import LoadingIndicator from 'components/shared/LoadingIndicator'
import LoadingOverlay from 'components/shared/LoadingOverlay'
import TableLayout from 'components/TableLayout'
import React, { useState } from 'react'
import { Button, Dropdown } from 'react-bootstrap'
import { useParams } from 'react-router-dom'
import parse from 'html-react-parser'
import { useGetClientReportsListQuery } from 'store/services/resource'
import { convertToMomentDate, dateFormatLocal, userFullName } from 'helpers/common'
import { useGetReportOptionsQuery, useLazyGetFileUrlQuery } from 'store/services/utility'
import Switch from 'react-switch';
import { usePublishDocumentMutation } from 'store/services/clients/attachment'
import TableHeader from 'components/shared/FormComponents/TableHeader'
import { useSelector } from 'react-redux'

export const ListReports = () => {
    const { id: clientId } = useParams();

    const [publishResource, { isLoading: publishResourceLoading }] = usePublishDocumentMutation();
    const [reports, setReports] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(5);
    const [filter, setFilter] = useState({ search: "", status: "", sort: { column: "id", direction: "desc" } });


    const { data, isLoading, isFetching, isError, refetch } = useGetClientReportsListQuery({ id: clientId, ...filter, page: currentPage, limit: pageSize })
    const totalRecords = data?.totalRecords || 0;
    const totalPages = Math.ceil(totalRecords / pageSize);
    const { data: reportOptions, isLoading: reportOptionsLoading } = useGetReportOptionsQuery()

    const profile = useSelector((state) => state?.auth?.user)
    
    const column = [
        {
            head: "Name",
            accessor: "attachment_name",
            isComponent: true,
            // sorter: true,
            component: (item, ind) => (
                <h6 className="m-0 fw-bold themeBlue">{item?.attachment_name ? `${parse(item?.attachment_name)} - ${item?.therapistResources?.therapist_detail?.therapist_designation?.title} - ${dateFormatLocal(item?.createdAt)}` : "--"}</h6>
            ),
        },
        {
            head: "Created By",
            accessor: "createdBy",
            isComponent: true,
            // sorter: true,
            component: (item, ind) => (
                <h6 className="m-0 fw-bold themeBlue">{userFullName(item?.therapistResources)}</h6>
            ),
        },
        {
            head: "Published",
            accessor: "is_published",
            isComponent: true,
            component: (item, ind) => (
                <div className=" d-flex align-items-center">
                    <Switch
                        disabled={item?.therapistResources?.id != profile?.id}
                        uncheckedIcon={""}
                        checkedIcon={""}
                        onHandleColor={"#A3DF00"}
                        offHandleColor={"#A3DF00"}
                        onColor={"#E6E6E6"}
                        offColor={"#E6E6E6"}
                        height={18}
                        width={40}
                        onChange={() => handlePublish(item?.id)}
                        checked={item?.is_published == "yes"}
                    />
                </div>
            ),
        },
        {
            head: "Action",
            accessor: "",
            isComponent: true,
            component: (item) => (
                <div className="ActnBtn d-flex align-items-center  gap-10">
                    {/* <CommonToolTip
                text={"Checlist"}
                component={<Button
                  className="p-0"
                  variant="transparent"
                  type="button"
                  onClick={() => { setCurrentEntry(item); setCheckListModal(true) }}
                >
                  <CheckIcon />
                </Button>}
              /> */}
                    {/* <CommonToolTip
                        text={"Delete"}
                        component={<Button
                            className="p-0"
                            variant="transparent"
                            type="button"
                            onClick={() => {

                                setCurrentEntry(item);
                                setModalType("delete");
                                setShowModal(true);
                            }}
                        >
                            <DeleteIcon />
                        </Button>}
                    /> */}
                    <CommonToolTip
                        text={"View"}
                        component={<Button
                            onClick={() => handleViewPdf(item?.attachment_key)}
                            className="p-0"
                            variant="transparent"
                            type="button"
                        >
                            <ViewDocumentIcon />
                        </Button>}
                    />
                </div>
            ),
        },
    ]
    const [getFileUrl, { isLoading: getFileLoading, isFetching: getFileFetching }] = useLazyGetFileUrlQuery();

    const handleViewPdf = async (name) => {

        try {
            const url = await getFileUrl(name).unwrap();
            if (url) window.open(url, '_blank');

        } catch (err) { console.error("Error assigning therapist", err); }
    };

    const handlePublish = async (resourceId) => {
        try {

            if (publishResourceLoading) return;
            const result = await publishResource({ clientId, resourceId })
            if (result?.error) return;

            typeof refetch == "function" && refetch();
            successMessageToast(result?.data?.message, { toastId: "handlePublish" });

            const list = cloneDeep(reports);
            const record = list?.find(x => x?.id == resourceId);
            record.is_published = record.is_published === "yes" ? "no" : "yes";

            setReports(list);
        } catch (err) { console.log("Error publishing Resource") };
    };


    const handlePageChange = (page) => {
        window.scrollTo(0, 0);
        setCurrentPage(page);
    };

    const handleFilterChange = (key) => (value) => {
        setFilter((prevState) => ({
            ...prevState,
            [key]: value,
        }));
        setCurrentPage(1); // Reset to first page when filter changes
    };

    const resetFilter = () => {
        setFilter({ search: "", status: "", sort: { column: "id", direction: "desc" } });
        setCurrentPage(1)
    };

    return (
        <div className="table-outer my-4">
            <div className="left">
                <TableHeader
                    heading={"Reports"}
                    hideStatusFilter
                    handleFilterChange={handleFilterChange}
                    resetFilter={resetFilter}
                    filter={filter}
                    searchPlaceholder="Report name"
                    filterComponent={
                        <li className="">
                            <Dropdown
                                onSelect={handleFilterChange("attachment_name")}>
                                <Dropdown.Toggle
                                    variant="transparent"
                                    className="border-0 d-flex align-items-center  justify-content-center"
                                    id="dropdown-basic"
                                >
                                    {reportOptions?.find(x => x?.title == filter.attachment_name)?.title || "Report Type"}
                                    <span className="icn ms-2">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="12"
                                            height="8"
                                            viewBox="0 0 12 8"
                                            fill="none"
                                        >
                                            <path
                                                d="M1.415 0.298828L6 4.731L10.585 0.298828L12 1.66666L6 7.46666L0 1.66666L1.415 0.298828Z"
                                                fill="black"
                                            />
                                        </svg>
                                    </span>
                                </Dropdown.Toggle>
                                <Dropdown.Menu >
                                    {
                                        reportOptions?.map((item, index) => {
                                            return <Dropdown.Item
                                                key={index}
                                                eventKey={item?.title}
                                                style={filter.attachment_name == item.id ? { background: "#f3f3f3" } : {}}
                                            >
                                                {item?.title}
                                            </Dropdown.Item>
                                        })
                                    }
                                </Dropdown.Menu>
                            </Dropdown>
                        </li>
                    }
                >
                </TableHeader>
            </div>
            {isLoading ? (
                <div style={{ height: "200px" }}>
                    <LoadingIndicator />
                </div>
            ) : isError ? (
                <ErrorComponent />
            ) : (
                <>
                    {(isFetching || getFileFetching || publishResourceLoading) && <LoadingOverlay />}
                    <TableLayout
                        height={"360px"}
                        data={data?.records || []}
                        column={column}
                    // url={PRIVATE_CLIENT_DETAIL.replace("/:id", "")}
                    // handleSort={handleFilterChange("sort")}
                    // filter={filter}
                    />
                </>
            )}
            <CstmPagination
                totalPages={totalPages}
                activePage={currentPage}
                handlePageChange={handlePageChange}
            />
        </div>
    )
}
